import { CancelConfirmModal } from 'app/components/cancel-confirm-modal';

interface VisitCancelModalProps {
  isOpen: boolean;
  visitorName: string;
  /** Formatted "Tomorrow · 9:00 AM – 6:00 PM". */
  when: string;
  isCancelling: boolean;
  isError: boolean;
  onConfirm: () => void;
  /** Keep the visit / dismiss (overlay click, Esc, or the "Keep visit" button). */
  onClose: () => void;
}

/**
 * Cancel-confirmation for a visit (Lis, MBX-950 — cancel inline, no redirect into the miniapp).
 * Copy and test-id prefix only; {@link CancelConfirmModal} owns the shape and the focus/error/in-flight
 * behaviour it shares with every other cancellable.
 */
export const VisitCancelModal = ({
  isOpen,
  visitorName,
  when,
  isCancelling,
  isError,
  onConfirm,
  onClose,
}: VisitCancelModalProps): JSX.Element => (
  <CancelConfirmModal
    isOpen={isOpen}
    namespace="visitCancel"
    testIdPrefix="visit-cancel"
    subject={{ visitor: visitorName }}
    when={when}
    isCancelling={isCancelling}
    isError={isError}
    onConfirm={onConfirm}
    onClose={onClose}
  />
);
